import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { ActivatedRoute, Router } from "@angular/router";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { CommonService } from "../../../common/common.service";


import { NgxSpinnerService } from 'ngx-spinner';
import Swal from "sweetalert2";
import { PartnerService } from '../../partner-management/partner.service';
import { OrganizationService } from '../organization.service';
import { ImageCroppedEvent } from 'ngx-image-cropper';
import { Route } from '@angular/compiler/src/core';
// import Swal from "sweetalert2";
@Component({
  selector: 'app-add-organization',
  templateUrl: './add.component.html',
  styleUrls: ['./add.component.scss']
})
export class AddOrganizationComponent implements OnInit {

  @Output() imageUploaded = new EventEmitter();
  @Output() imageError = new EventEmitter();
  @Output() imageLoadedToContainer = new EventEmitter();
  @Output() croppingCanceled = new EventEmitter();

  profilePic:string;
  organizationForm: FormGroup;
  formSubmitted: boolean = false;
  showDesciptionError: boolean = true;
  featureList = [];
  finalFeatureList = [];
  isUploading:boolean = true;
  isLoading:boolean = false;
  temp: any;
  organizationId = "";
  organizationList = []
  emailPattern = /^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+$/;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private fb: FormBuilder,
    private spinner: NgxSpinnerService,
    private commonService: CommonService,
    private OrganizationService: OrganizationService,
  ) { }

  ngOnInit() {
    this.route.queryParams.subscribe(param => {
      if(param['organizationId'] && param['organizationId'] !== '') {
        this.organizationId = param['organizationId'];
        this.getOrgs();
      }

    });
    this.initialiseForms();
    this.organizationForm.reset();
  }

  getOrgs() {
    let param = 'organizationId='+this.organizationId;
    this.OrganizationService.getOrganizationsApi(param).subscribe(res => {
      this.spinner.show();
      if ((res["status"] == "Success")) {
        this.organizationList = res.data.organizationList[0];
        this.patchVal();
        // this.plancount = this.organizationList.length
        this.spinner.hide();
      } else {
        this.spinner.hide();
        Swal.fire({
          type: "error",
          title: "Error",
          text: res.msg
        });
      }
    }, err => {
      this.spinner.hide();
    });

  }

  patchVal() {

    this.organizationForm.patchValue({
      organizationName: this.organizationList["organizationName"],
      mobile: this.organizationList["mobile"],
      address:this.organizationList["address"],
      image:this.organizationList['image'],
      email:this.organizationList['email'],
    });
    this.profilePic = this.organizationList['image']
  }



  initialiseForms() {
    this.organizationForm = this.fb.group({
      organizationName: ["", [Validators.required]],
      mobile: ["", [Validators.required]],
      address: ["",[Validators.required]],
      email:["", [Validators.required, Validators.pattern(this.emailPattern)]],
      image: [""],

    });
  }

  checkFinalPost () {
    if(this.organizationId && this.organizationId !== '') {
      this.editPlan() 
    }else {
      this.Addplan()
    }
  }

  editPlan() {
    this.formSubmitted = true;
    if (this.organizationForm.valid) {
      if(this.organizationForm.controls.image.value == null) {
        Swal.fire({
          type: "error",
          title: "Error",
          text: 'Image is required'
          
        });
        return
      }
       let request = this.organizationForm.value;
       request['organizationId'] = this.organizationId
      this.OrganizationService.editOrganizationApi(request).subscribe(data => {
        if ((data["status"] == "Success")) {
          Swal.fire("Success", "Organization editted successfully!", "success");
          this.router.navigate(["/main/organization/view"]);
        } else {
          Swal.fire({
            type: "error",
            title: "Error",
            text: data.msg
          });
        }
      });
    }
  }
  onlyNumberKey(event) {

    return (event.charCode == 8 || event.charCode == 0) ? null : event.charCode >= 48 && event.charCode <= 57;
  }
  Addplan() {
    this.formSubmitted = true;
    if (this.organizationForm.valid) {
      if(this.organizationForm.controls.image.value == null) {
        Swal.fire({
          type: "error",
          title: "Error",
          text: 'Image is required'
          
        });
        return
      }
       let request = this.organizationForm.value;
      this.OrganizationService.saveOrganizationApi(request).subscribe(data => {
        if ((data["status"] == "Success")) {
          Swal.fire("Success", "Organization added successfully!", "success");
          this.router.navigate(["/main/organization/view"]);
        } else {
          Swal.fire({
            type: "error",
            title: "Error",
            text: data.msg
          });
        }
      });
    }
  }

  imageChangedEvent: any = '';
  imageChangedEvent1: any = '';
  croppedImage: any = '';
  fileChangeEvent(event: any): void {
    this.spinner.show()
    let file, img;
    if ((file = event.target.files[0]) && (file.type === "image/png" || file.type === "image/jpeg")) {
        img = new Image();
        this.imageChangedEvent = event;
    }
     else {
          // Swal.fire({
          //     icon: 'error',
          //     html: 'Unsupported File Type. Only jpeg and png is allowed!'
          // });
      }
      this.spinner.hide()
  }

  b64toBlob(dataURI) {
    var byteString = atob(dataURI.split(',')[1]);
    var ab = new ArrayBuffer(byteString.length);
    var ia = new Uint8Array(ab);
    for (var i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i);
    }
    return new Blob([ab], { type: 'image/jpeg' });
}

  save() {

    const  blob = this.b64toBlob(this.croppedImage);
    this.imageChangedEvent = null;
    this.spinner.show()
    this.OrganizationService.uploadImage(blob).subscribe(res => {
      this.spinner.hide()

        if ( res['status'] === 'Success') {
            this.profilePic = res['data'].thumb;
            this.organizationForm.controls['image'].setValue(this.profilePic);
          //  console.log('Image url',this.profilePic)
  
        }
    });
  }
  imageCropped(event: ImageCroppedEvent) {
    this.croppedImage = event.base64;
   // console.log(this.croppedImage,'CropImage')
  }
  
  imageLoaded() {
    // show cropper
  }
  cropperReady() {
    // cropper ready
  }

  cancel(): void {
    this.croppedImage = null;
    this.imageChangedEvent = null;
    this.isUploading = false;
    setTimeout(() => {
        /** spinner ends after 1 seconds */
        this.isUploading= true;
      }, 1000);
  }
  cancelForm() {
    this.organizationForm.reset();
    this.router.navigate(["/main/organization/view"]);
  }

}


